import { ErrorMessage, Field, Form, Formik } from "formik";
import React, { useEffect, useMemo, useState } from "react";
import Select from "react-select";
import * as Yup from "yup";
import {
  leadTypeOptions,
  targetRoleStatusOptions,
} from "../../reactSelectRowData";
import moment, { max } from "moment";
import { searchLeadApi } from "../../store/saga/requests/campaignRequests";
import toast from "react-hot-toast";
import {
  ColumnDef,
  flexRender,
  getCoreRowModel,
  useReactTable,
} from "@tanstack/react-table";
import { ICampaignLeadListTypes } from "../../types/campaignTypes";
import { StatusBadge } from "../../components/badge";
import { NavLink } from "react-router-dom";

export default function AgentDashboard() {
  const [leadList, setLeadList] = useState<ICampaignLeadListTypes[]>([]);

  const initialValues = {
    phoneNumber: null,
    roles: null,
    leadType: null,
  };

  const validationSchema = Yup.object().shape({
    phoneNumber: Yup.string()
      .strict(true)
      .min(10, "Please enter Phone Number")
      .required("Please enter Phone Number"),
    roles: Yup.string().strict(true).required("Please enter Roles"),
    leadType: Yup.string().strict(true).required("Please enter Lead Type"),
  });
  const data = useMemo(() => leadList, [leadList]);
  const columns = useMemo<ColumnDef<ICampaignLeadListTypes>[]>(
    () => [
      {
        accessorKey: "name",
        cell: (info) => (
          <NavLink to={`/agent/campaigns/lead/${info.row.original.leadId}`}>
            <span className="tb-link">{info.row.original.name}</span>
          </NavLink>
        ),
        header: "Name",
      },
      {
        accessorKey: "role",
        header: "Role",
      },

      {
        accessorKey: "status",
        header: "Status",
        cell: (info) => <StatusBadge>{info.row.original.status}</StatusBadge>,
      },
      {
        accessorKey: "createdAt",
        cell: (info) => moment(info.row.original.createdAt).format("lll"),
        header: "Created At",
      },
    ],
    [leadList]
  );
  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
    // getFilteredRowModel: getFilteredRowModel(),
    // getPaginationRowModel: getPaginationRowModel(),
    debugTable: false,
    manualPagination: true,
    // pageCount: customerListPageCount
    //   ? Math.ceil(customerListPageCount / pageSize)
    //   : undefined,
    // state: {
    //   pagination,
    // },
    // onPaginationChange: setPagination,
  });
  return (
    <div>
      <div className="font-semibold	text-2xl">Get Lead Details</div>
      <div></div>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={async (values, actions) => {
          await searchLeadApi(values)
            .then((response) => {
              setLeadList(response.data.data);

              toast.success("Data Fetch Successfull", {
                duration: 3000,
              });
            })
            .catch((error) => {
              toast.error(error?.response?.data?.message, {
                duration: 3000,
              });
            })
            .finally(() => {
              // setLoading(false);
            });
        }}
      >
        {(formikProps) => (
          <>
            {/* {console.log(formikProps)}{" "} */}
            <Form className="flex gap-8 items-center w-[100%] flex-wrap justify-center">
              <div className="">
                <div className="flex flex-wrap -mx-3 mb-6">
                  <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      Phone Number *
                    </label>
                    <Field
                      className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                      // className="appearance-none block w-full bg-gray-200 text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                      id="phoneNumber"
                      name="phoneNumber"
                      type="tel"
                      maxLength={10}
                      //   placeholder="Jane"
                    />
                    <ErrorMessage
                      component="div"
                      name="phoneNumber"
                      className="text-red-500 text-xs "
                    />
                  </div>
                  <div className="w-full md:w-1/2 px-3">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      User Role *
                    </label>
                    <Select
                      classNames={{
                        control: (state) =>
                          state.isFocused
                            ? "!appearance-none !w-full !outline-none !bg-white !border-gray-500 !py-1 !bg-white"
                            : "!bg-gray-200 !text-gray-700 !border !border-gray-200 !rounded !py-1 !leading-tight ",
                      }}
                      isSearchable
                      id="roles"
                      name="roles"
                      options={targetRoleStatusOptions}
                      placeholder="Select Call Type"
                      noOptionsMessage={() => "No matching record found"}
                      onChange={(option: any) => {
                        formikProps.setFieldValue("roles", option.value);
                      }}
                    />
                    <ErrorMessage
                      component="div"
                      name="roles"
                      className="text-red-500 text-xs "
                    />
                  </div>
                </div>

                <div className="flex flex-wrap -mx-3 mb-6">
                  <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      Call Type *
                    </label>
                    <Select
                      classNames={{
                        control: (state) =>
                          state.isFocused
                            ? "!appearance-none !w-full !outline-none !bg-white !border-gray-500 !py-1 !bg-white"
                            : "!bg-gray-200 !text-gray-700 !border !border-gray-200 !rounded !py-1 !leading-tight ",
                      }}
                      isSearchable
                      id="leadType"
                      name="leadType"
                      options={leadTypeOptions}
                      placeholder="Select Call Type"
                      noOptionsMessage={() => "No matching record found"}
                      onChange={(option: any) => {
                        formikProps.setFieldValue("leadType", option.value);
                      }}
                    />
                    <ErrorMessage
                      component="div"
                      name="leadType"
                      className="text-red-500 text-xs "
                    />
                  </div>
                </div>
              </div>
              <button
                className={`bg-primary-dark px-4 py-2 rounded-md text-white text-[1.1rem] font-[500] ml-5 w-[150px`}
                type="submit"
              >
                Search
              </button>
            </Form>
          </>
        )}
      </Formik>
      {leadList && (
        <section className="bg-white p-5 rounded mt-4">
          <div className="table-wrapper">
            <table className="p-2 w-full ">
              <thead className="w-full bg-primary table-head-sticky">
                {table.getHeaderGroups().map((headerGroup) => (
                  <tr key={headerGroup.id} className="">
                    {headerGroup.headers.map((header) => (
                      <th key={header.id} className="tb-head">
                        {header.isPlaceholder
                          ? null
                          : flexRender(
                              header.column.columnDef.header?.toString(),
                              header.getContext()
                            )}
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody className="">
                {table.getRowModel().rows.length > 0 ? (
                  table.getRowModel().rows.map((row) => (
                    <tr key={row.id} className="tb-row">
                      {row.getVisibleCells().map((cell) => (
                        <td key={cell.id} className="tb-data  ">
                          {flexRender(
                            cell.column.columnDef.cell,
                            cell.getContext()
                          )}
                        </td>
                      ))}
                    </tr>
                  ))
                ) : (
                  <tr>No Data Found</tr>
                )}
              </tbody>
            </table>
          </div>
        </section>
      )}
    </div>
  );
}
